import { DateRangePreset } from '@ugo/utils';
import { atomWithStorage } from 'jotai/utils';

export const datePresetValueAtom = atomWithStorage<DateRangePreset>(
  'date_preset_value',
  DateRangePreset.ThisWeek
);
